import { getTexts } from '../imports'
import strings from './localized.json'

export default (locale) => {
    const texts = getTexts(strings)[locale]
    return {
        processStarted: texts.clientPorcessStarted,
        authorizing: texts.clientAuthorizing,
        authorizationFailed: texts.clientAuthorizationFailed,
        refresh: texts.clientRefresh,
        starting: texts.clientStarting,
    }
}



// WEBPACK FOOTER //
// ./src/features/LaunchProgressBar/localization/index.js